<template>
  <div id="app">
    <div v-if="!$store.state.isEmbed" class="top-banner">
      The NSW Government stopped publishing COVID-19 data by postcode/council on
      20 Oct 2023.
      <br /><br />
      This site remains available as an archive of the spread of the COVID-19
      pandemic. For ongoing data, see the fortnightly
      <a
        href="https://www.health.nsw.gov.au/Infectious/covid-19/Pages/reports.aspx"
        target="_blank"
        >NSW Respiratory Surveillance Report</a
      >. <br /><br />
      Providing the data to you all through the height of the pandemic was so
      incredibly rewarding, so thanks for coming! My next project is focused on
      <a
        href="https://property.carto.au/sydney/house-prices/by-suburb/map"
        target="_blank"
        >mapping Sydney&rsquo;s house prices</a
      >, much less important, but if it interests you, check it out!
    </div>
    <div class="nav" v-if="!$store.state.isEmbed">
      <!-- Image source: https://commons.wikimedia.org/wiki/File:Virus_green.svg -->
      <div class="nav-top">
        <div class="nav-top-spacer left" />
        <router-link to="/" class="nav-top-logo">
          <svg width="450" height="450" viewBox="0 0 450 450" style="isolation:isolate" v-bind:svg-inline="''" v-bind:class="'nav-top-logo-img'" v-bind:title="'COVID-19 NSW'" v-bind:width="'450'" v-bind:height="'450'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><clipPath id="a"><path d="M0 0h450v450H0z"/></clipPath></defs><g clip-path="url(#a)"><path d="M300.587 315.19c-12.094 0-6.067-28.179-6.067-32.24 1.027-2.006-9.05-121.916-9.05-121.916 1.027-4.062 3.023-9.1 10.077-9.1l2.006-.001c16.145 0 30.235-13.102 30.235-29.207 0-16.145-13.102-29.257-30.235-29.257-16.095 0-30.235 13.112-30.235 29.257 0 3.024 0 6.017 1.028 9.05 0 0 6.017 15.118-7.054 13.112 0 0-113.884 39.285-118.923 40.313-14.14 25.196-50.391 12.094-61.497 4.01-3.024-4.008-9.051-7.039-16.095-7.039-12.216.086-22.103 9.955-22.213 22.171 1.028 11.097 11.106 21.175 23.2 21.175 4.062 0 9.1-1.028 12.094-3.023 18.14-9.07 51.409-3.044 55.43 13.1v1.03c1.008 2.982 24.188 49.362 27.222 53.373 15.117 28.229-22.213 39.336-22.213 39.336-10.078 0-19.128 9.05-19.128 20.156 0 12.083 10.078 22.161 22.172 22.161 12.073 0 22.152-10.078 22.152-22.172 3.033-23.18 15.117-38.297 37.33-39.325 2.983 1.028 57.435-2.983 61.446-4.011 16.146 3.024 7.055 16.146 7.055 38.298 0 16.105 13.102 29.227 30.235 29.227 16.135 0 30.234-13.122 30.234-29.227 1.018-16.125-12.094-29.247-29.216-29.247h.01z" fill="#2E7D32"/><path d="M367.123 167.06c-9.1 0-16.145 4.052-19.179 12.074-9.05 13.112-28.219 16.145-40.313 10.078-2.005-5.039-129-39.285-129-38.257-16.103 9.05-31.219-19.178-30.232-32.29v-.978c1.017-3.033 1.017-6.067 1.017-9.1 0-16.095-13.1-29.207-30.234-29.207-16.145 0-30.234 13.102-30.234 29.207 0 13.11 9.05 23.19 19.13 28.23 17.172 7.053 40.311 27.21 38.306 41.34 7.055 12.083-9.05 74.558-8.063 79.597-9.06 9.1-27.21 7.055-34.257 4.062-3.023-4.062-9.05-6.067-15.117-6.067-16.145 0-30.234 13.101-30.234 29.206.001 16.146 13.102 29.257 30.235 29.257 10.078 0 18.14-4.06 24.168-12.094 9.1-13.1 24.218-25.195 37.33-25.195 2.005 2.993 164.234-60.469 164.234-61.487 1.028-6.067 25.195-12.094 46.38-7.055h6.067c12.084 0 22.162-10.078 22.162-22.152 0-12.134-10.078-19.18-22.172-19.18l.01.01z" fill="#4CAF50"/><path d="M315.704 225.514c0 50.08-40.625 90.704-90.704 90.704-50.08 0-90.704-40.625-90.704-90.704 0-50.08 40.625-90.704 90.704-90.704 50.08 0 90.704 40.625 90.704 90.704z" fill="#4CAF50"/><path d="M248.18 311.179c3.044-6.067-8.063-8.063-17.113-8.063-9.1 0-18.151 5.039-16.145 11.086 24.167 36.262 6.067 41.3-5.039 48.396-9.051 4.01-15.118 15.117-15.118 25.195C194.765 403.888 207.867 417 225 417s30.235-13.102 30.235-29.207c1.028-28.229-17.133-67.564-7.055-76.614zm126.965-56.458c-6.017.003-12.084 1.03-16.095 4.064-18.151 7.045-34.296-6.067-46.38-14.14-6.016-4.01-13.1 6.068-15.117 9.1-2.006 3.025-5.04 17.124 7.055 17.124 20.156-7.055 45.352 28.219 45.352 28.219 4.05 10.078 15.117 16.105 27.24 16.105 16.097 0 30.237-13.06 30.237-29.207-3.034-18.141-16.146-31.262-32.291-31.262zM198.776 79.383c19.18 39.285 18.15 54.402 7.096 58.454-9.101 7.054 6.016 16.105 17.122 14.11 11.056-2.017 21.134-7.056 14.09-17.134-17.123-30.234 5.04-50.39 5.04-50.39 7.054-4.012 12.093-13.103 12.093-22.173 0-16.125-13.072-29.247-30.235-29.247-17.133 0-30.235 13.112-30.235 29.257 0 4.01 1.018 9.05 3.024 13.102 0 2.993 0 2.993 2.016 4.021h-.01z" fill="#8BC34A"/><path d="M208.855 225.514c-16.095 0-30.235-13.102-30.235-29.207 0-16.145 13.112-29.257 30.235-29.257 17.173 0 30.234 13.112 30.234 29.257 0 16.095-13.06 29.207-30.234 29.207z" fill="#C5E1A5"/><path d="M193.737 269.838c-9.05 0-15.117-6.017-15.117-15.117 0-9.05 6.067-15.118 15.117-15.118 9.1 0 15.118 6.067 15.118 15.118 0 9.1-6.017 15.117-15.118 15.117z" fill="#F1F8E9"/><path d="M247.172 285.983c-12.094 0-22.172-10.078-22.172-22.172 0-12.074 10.078-22.152 22.172-22.152 12.074 0 22.152 10.078 22.152 22.162 0 12.087-10.078 22.165-22.162 22.165h.01z" fill="#DCEDC8"/></g></svg>
          <div class="nav-top-logo-title">COVID-19 NSW</div>
        </router-link>
        <div class="nav-top-spacer right" />
        <div class="nav-top-links">
          <a href="https://www.buymeacoffee.com/booligoosh" target="_blank">
            Tip jar
          </a>
          <router-link :to="{ name: 'AboutPage' }">About site</router-link>
        </div>
      </div>
      <nav class="nav-links">
        <router-link
          :to="{
            name:
              $route.name === 'CouncilPage' ||
              $route.name === 'CouncilsPage' ||
              $route.name === 'CouncilsVaccinationsPage'
                ? 'CouncilsPage'
                : 'PostcodesPage',
          }"
          :class="{
            active:
              $route.name === 'PostcodesPage' || $route.name === 'CouncilsPage',
          }"
        >
          Cases
        </router-link>
        <router-link
          :to="{
            name:
              $route.name === 'CouncilPage' ||
              $route.name === 'CouncilsPage' ||
              $route.name === 'CouncilsVaccinationsPage'
                ? 'CouncilsVaccinationsPage'
                : 'PostcodesVaccinationsPage',
          }"
          :class="{
            active:
              $route.name === 'PostcodesVaccinationsPage' ||
              $route.name === 'CouncilsVaccinationsPage',
          }"
        >
          Vaccinations
        </router-link>
      </nav>
      <GlobalChooser v-if="$route.meta.showSearch" />
      <a
        class="nav-back-btn"
        v-if="$route.name === 'PostcodePage' || $route.name === 'CouncilPage'"
        @click="
          $store.getters.canGoBack
            ? $router.go(-1)
            : $router.push({
                name:
                  $route.name === 'CouncilPage'
                    ? 'CouncilsPage'
                    : 'PostcodesPage',
              })
        "
      >
        ← Go back
      </a>
    </div>
    <div class="page-wrapper">
      <router-view class="page" />
    </div>
  </div>
</template>

<script>
import GlobalChooser from "./components/GlobalChooser.vue";
export default {
  components: { GlobalChooser },
  created() {
    if (window.location.origin === "https://covid19nsw.netlify.com") {
      window.location.href = window.location.href.replace(
        /^https:\/\/covid19nsw.netlify.com/,
        "https://covid19nsw.ethan.link"
      );
    }
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Inter var";
  font-weight: 100 900;
  font-display: optional;
  font-style: normal;
  font-named-instance: "Regular";
  src: url("/fonts/Inter-roman.var.woff2?v=3.19") format("woff2");
}
@font-face {
  font-family: "Inter var";
  font-weight: 100 900;
  font-display: optional;
  font-style: italic;
  font-named-instance: "Italic";
  src: url("/fonts/Inter-italic.var.woff2?v=3.19") format("woff2");
}

html {
  font-family: "Inter var", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-feature-settings: "ss01";
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

html,
body,
#app {
  height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  .page-wrapper {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    flex-grow: 1;
  }

  .nav,
  .page {
    padding: 1.5rem;
    width: 1400px;
    max-width: 100%;
    margin: 0 auto;
  }
  .nav {
    padding-bottom: 0;
    // NOTE: If changing $nav-breakpoint,
    // change in GlobalChooser.vue as well
    $nav-breakpoint: 700px;

    &-top {
      display: flex;
      justify-content: center;
      align-items: center;

      $small-logo-title-breakpoint: 333px;
      $top-links-width: 9rem;

      &-spacer {
        flex-grow: 1;

        &.left {
          margin-left: $top-links-width;

          @media screen and (max-width: $nav-breakpoint) {
            display: none;
          }
        }
      }
      &-logo {
        display: flex;
        align-items: center;
        color: inherit;
        text-decoration: none;

        &-img {
          width: auto;
          height: 2rem;
          margin-right: 0.25rem;

          @media screen and (max-width: $small-logo-title-breakpoint) {
            height: 1.5rem;
          }
        }
        &-title {
          font-weight: bold;
          display: flex;
          align-items: center;

          @media screen and (max-width: $small-logo-title-breakpoint) {
            font-size: 0.9rem;
          }
        }
      }
      &-links {
        flex-shrink: 0;
        display: flex;
        justify-content: flex-end;
        width: $top-links-width;

        @media screen and (max-width: $nav-breakpoint) {
          width: unset;
        }

        a {
          font-weight: normal;
          font-size: 0.85rem;
          color: inherit;
          opacity: 0.6;
          margin-left: 0.7rem;
        }
      }
    }

    &-links {
      // display: none;
      font-size: 0.9rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 0.5rem;
      width: max-content;
      margin: 0 auto;
      margin-top: 1rem;

      @media screen and (max-width: $nav-breakpoint) {
        width: 100%;
      }

      a {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: inherit;
        text-decoration: none;
        padding: 0.5rem 1rem;
        background: hsl(0, 0%, 97%);
        border-radius: 7px;
        border: 1px solid hsl(0, 0%, 80%);
        margin: 0 auto;
        font-size: 0.9rem;

        &:hover {
          background: hsl(0, 0%, 96%);
        }

        &.active {
          background: hsl(0, 0%, 92%);
        }
      }
    }

    &-back-btn {
      display: block;
      width: max-content;
      color: inherit;
      opacity: 0.5;
      font-size: 0.9rem;
      margin-top: 0.5rem;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .page {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding-top: 1rem;

    &-loading,
    &-error {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    &-error {
      color: red;
    }

    > :first-child,
    > :first-child > :first-child {
      margin-top: 0;
    }
  }
}

h1 {
  margin-top: 0;
}

button,
input {
  // Override default 2px margins in Safari
  margin: 0;
}

.top-banner {
  background: #eee;
  padding: 1rem 1.5rem;
  font-size: 0.8rem;
}
</style>
